import * as React from 'react';
import {connect} from 'react-redux';
import FormSelect, {FormSelectProps} from 'cl-form/FormSelect/index';
import * as _ from 'lodash';
import {FormSelectOption} from "cl-form/utils/orderByUtils";

const EndingReasonSelect: React.SFC<FormSelectProps> = (props) => {
  return <FormSelect {...props}/>
};

export default connect((state: any) => {
  return {
    options: _.map(state.general.eBayEndingReasons, (label: string, value: string) => ({label, value} as FormSelectOption))
  };
}, {})(EndingReasonSelect);
